export const FlexRow = ' d-flex align-items-center justify-content-center flex-row'
export const FlexCol = ' d-flex align-items-center justify-content-center flex-column'